var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTxtOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 304,
    viewBox: "0 0 239 304",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.823 0H0.84375V303.188H238.348V50.525L187.823 0Z",
    fill: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.363 166.37H60.8203V179.235H110.363V166.37Z",
    fill: "#D1D3D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.363 141.729H60.8203V154.594H168.363V141.729Z",
    fill: "#D1D3D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M178.371 117.087H60.8203V129.952H178.371V117.087Z",
    fill: "#D1D3D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.029 92.4451H60.8203V105.31H143.029V92.4451Z",
    fill: "#D1D3D3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M178.371 67.804H60.8203V80.669H178.371V67.804Z",
    fill: "#D1D3D3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1897 273.871H68.2267V236.492H56.5117V225.892H92.8727V236.492H81.1897V273.871Z",
    fill: "#A4A9AD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M142.951 273.871H127.953L118.601 258.873L109.345 273.871H94.6758L110.593 249.324L95.6278 225.891H110.001L118.665 240.725L127.001 225.891H141.802L126.607 250.34L142.951 273.871Z",
    fill: "#A4A9AD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M169.503 273.871H156.54V236.492H144.824V225.892H181.185V236.492H169.502L169.503 273.871Z",
    fill: "#A4A9AD"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M195.642 25.263H0.84375V0H187.823L195.642 25.263Z",
    fill: "#FF9900"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M187.824 50.525H238.349L187.824 0V50.525Z",
    fill: "#D1D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxtOrange);
export default __webpack_public_path__ + "static/media/txt-orange.72ceb25b65f4c50115a8e7f10af42eac.svg";
export { ForwardRef as ReactComponent };